<template>
    <div>
      <md-steppers :md-active-step.sync="active" md-vertical md-linear>
        <!-- Primo step -->
        <md-step id="first" md-label="Iscriviti ora" :md-error="firstStepErrorTop" md-description="Inserisci i dati richiesti per completare la domanda d'iscrizione" :md-editable="false" :md-done.sync="first">
          <!-- Form primo step -->
            <form novalidate class="md-layout" @submit.prevent="validateUser">
            <md-card class="md-layout-item ">
              <md-card-header>
                <div class="md-title">Campi anagrafici Caponucleo</div>
              </md-card-header>

              <md-card-content>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('nome_cn')">
                      <label for="nome_cn">Nome</label>
                      <md-input name="nome_cn" id="nome_cn" v-model="form.nome_cn" :disabled="sending" />
                      <span class="md-error" v-if="!$v.form.nome_cn.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.nome_cn.minlength">Nome non valido</span>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('cognome_cn')">
                      <label for="cognome_cn">Cognome</label>
                      <md-input name="cognome_cn" id="cognome_cn"  v-model="form.cognome_cn" :disabled="sending" />
                      <span class="md-error" v-if="!$v.form.cognome_cn.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.cognome_cn.minlength">Cognome non valido</span>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('cf_cn')">
                      <label for="cf_cn">Codice Fiscale</label>
                      <md-input name="cf_cn" id="cf_cn"  v-model="form.cf_cn" :disabled="sending" maxlength="16"/>
                      <span class="md-error" v-if="!$v.form.cf_cn.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.cf_cn.maxLength">Codice fiscale non valido</span>
                      <span class="md-error" v-else-if="!$v.form.cf_cn.minLength">Codice fiscale non valido</span>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('email_cn')">
                      <label for="email_cn">Email</label>
                      <md-input name="email_cn" id="email_cn"  v-model="form.email_cn" :disabled="sending" />
                      <span class="md-error" v-if="!$v.form.email_cn.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.email_cn.minlength">Email non valida</span>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('idnucleo')">
                      <label for="idnucleo">Codice iscrizione al fondo</label>
                      <md-input name="idnucleo" id="idnucleo"  v-model="form.idnucleo" :disabled="sending" maxlength="6"/>
                      <span class="md-error" v-if="!$v.form.idnucleo.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.idnucleo.minlength">Codice non valido</span>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('prognucleo')">
                      <label for="prognucleo">Progressivo Codice Iscrizione</label>
                      <md-input name="prognucleo" id="prognucleo"  v-model="form.prognucleo" disabled/>
                      <span class="md-error" v-if="!$v.form.prognucleo.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.prognucleo.minlength">Email non valida</span>
                    </md-field>
                  </div>
                </div>

                <md-card-header style="padding-top: 25px">
                  <div class="md-title">Campi anagrafici Nuovo iscritto</div>
                </md-card-header>

                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('nome')">
                      <label for="nome">Nome</label>
                      <md-input name="nome" id="nome"  v-model="form.nome" :disabled="sending" />
                      <span class="md-error" v-if="!$v.form.nome.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.nome.minlength">Nome non valido</span>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('cognome')">
                      <label for="cognome">Cognome</label>
                      <md-input name="cognome" id="cognome"  v-model="form.cognome" :disabled="sending" />
                      <span class="md-error" v-if="!$v.form.cognome.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.cognome.minlength">Cognome non valido</span>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout md-gutter md-alignment-center-center">
                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('sesso')">
                      <label for="sesso">Sesso</label>
                      <md-select name="sesso" id="sesso" v-model="form.sesso" md-dense :disabled="sending">
                        <md-option></md-option>
                        <md-option value="M">Maschio</md-option>
                        <md-option value="F">Femmina</md-option>
                      </md-select>
                      <span class="md-error">Il campo è obbligatorio</span>
                    </md-field>
                  </div>
                  <p style="padding-right: 10px"> Data di nascita: </p>

                  <!-- Date artigianale - START -->
                  <div class="md-layout-item md-small-size-35">
                    <md-field :class="getValidationClass('day', 'datePicker')">
                      <label for="datePickerDay">Giorno</label>
                      <md-select name="datePickerDay" id="datePickerDay" v-model="datePicker.day" md-dense :disabled="sending">
                        <md-option v-for="day in datePickerData.days(datePicker.year, datePicker.month)" v-bind:value="day">{{day}}</md-option>
                      </md-select>
                      <span class="md-error" v-if="!$v.datePicker.day.required">Il campo è obbligatorio</span>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-50">
                    <md-field :class="getValidationClass('month', 'datePicker')">
                      <label for="datePickerMonth">Mese</label>
                      <md-select name="datePickerMonth" id="datePickerMonth" v-model="datePicker.month" md-dense :disabled="sending">
                        <md-option v-for="month in datePickerData.months" v-bind:value="month.value">{{month.text}}</md-option>
                      </md-select>
                      <span class="md-error" v-if="!$v.datePicker.month.required">Il campo è obbligatorio</span>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-50">
                    <md-field :class="getValidationClass('year', 'datePicker')">
                      <label for="datePickerYear">Anno</label>
                      <md-select name="datePickerYear" id="datePickerYear" v-model="datePicker.year" md-dense :disabled="sending">
                        <md-option v-for="year in datePickerData.years()" v-bind:value="year">{{year}}</md-option>
                      </md-select>
                      <span class="md-error" v-if="!$v.datePicker.year.required">Il campo è obbligatorio</span>
                      <!--<span class="md-error" v-if="$v.datePicker.year.maxRange">L'iscritto deve essere maggiorenne</span>-->
                      <!--<span class="md-error" v-if="$v.datePicker.year.minRange">L'iscritto deve avere meno di 55 anni</span>-->
                    </md-field>
                  </div>

                  <!-- END SECTION Datepicker artigianale-->
                </div>

                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('luogo_nascita')">
                      <label for="luogo_nascita">Luogo di nascita</label>
                      <md-input name="luogo_nascita" id="luogo_nascita" v-on:keyup="cityMonitor" v-model="form.luogo_nascita" :disabled="sending" />
                      <span class="md-error" v-if="!$v.form.luogo_nascita.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.luogo_nascita.minlength">Luogo di nascita non valido</span>
                      <span class="md-error" v-else-if="!$v.form.luogo_nascita.alphaSpaces()">Luogo di nascita non valido</span>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('cf')">
                      <label for="cf">Codice Fiscale</label>
                      <md-input name="cf" id="cf"  v-model="form.cf" :disabled="sending" maxlength="16"/>
                      <span class="md-error" v-if="!$v.form.cf.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.cf.maxLength">Codice fiscale non valido</span>
                      <span class="md-error" v-else-if="!$v.form.cf.minlength">Codice fiscale non valido</span>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('indirizzo')">
                      <label for="indirizzo">Indirizzo</label>
                      <md-input name="indirizzo" id="indirizzo"  v-model="form.indirizzo" :disabled="sending" />
                      <span class="md-error" v-if="!$v.form.indirizzo.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.indirizzo.minlength">Indirizzo non valido</span>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-50">
                    <md-field :class="getValidationClass('citta')">
                      <label for="citta">Città</label>
                      <md-input name="citta" id="citta" v-on:keyup="cityMonitor" v-model="form.citta" :disabled="sending" />
                      <span class="md-error" v-if="!$v.form.citta.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.citta.minlength">Città non valida</span>
                      <span class="md-error" v-else-if="!$v.form.citta.alphaSpaces()">Città non valida</span>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-50">
                    <md-field :class="getValidationClass('cap')">
                      <label for="cap">CAP</label>
                      <md-input name="cap" id="cap"  v-model="form.cap" :disabled="sending" maxlength="5"/>
                      <span class="md-error" v-if="!$v.form.cap.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.cap.minLength">CAP non valido</span>
                      <span class="md-error" v-else-if="!$v.form.cap.maxlength">CAP non valido</span>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('provincia')">
                      <label for="provincia">Provincia</label>
                      <md-input maxlength="2" name="provincia" id="provincia"
                                v-model="form.provincia" :disabled="sending" />
                      <span class="md-error" v-if="!$v.form.provincia.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.provincia.minlength">Provincia non valida</span>
                      <span class="md-error" v-else-if="!$v.form.provincia.maxLength">Provincia non valida</span>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('cellulare')">
                      <label for="cellulare">Cellulare</label>
                      <md-input name="cellulare" id="cellulare"  v-model="form.cellulare" :disabled="sending" />
                      <span class="md-error" v-if="!$v.form.cellulare.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.cellulare.minlength">Cellulare non valido</span>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('email')">
                      <label for="email">Email</label>
                      <md-input name="email" id="email"  v-model="form.email" :disabled="sending" />
                      <span class="md-error" v-if="!$v.form.email.required">Campo obbligatorio</span>
                      <span class="md-error" v-else-if="!$v.form.email.minlength">Email non valida</span>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-100">
                    <md-field :class="getValidationClass('stato_civile')">
                      <label for="stato_civile">Stato Civile</label>
                      <md-select name="stato_civile" id="stato_civile" v-model="form.stato_civile" md-dense :disabled="sending">
                        <md-option></md-option>
                        <md-option value="0">Single</md-option>
                        <md-option value="1">Convivente/Sposato</md-option>
                      </md-select>
                      <span class="md-error">Il campo è obbligatorio</span>
                    </md-field>
                  </div>
                </div>

              </md-card-content>

              <md-progress-bar md-mode="indeterminate" v-if="sending" />

              <!--<md-card-actions>-->
                <!--<md-button type="submit" class="md-primary" :disabled="sending">Create user</md-button>-->
              <!--</md-card-actions>-->
              <md-content style="padding: 10px 0 10px">
                <md-progress-spinner class="md-accent" md-mode="indeterminate" :md-diameter="30" v-if="sending"></md-progress-spinner>
              </md-content>
              <md-content style="padding: 20px 0 30px">
                <md-button style="background-color: rgb(255, 120, 55)" class="md-raised md-primary" @click="validateUser()">Prosegui</md-button>
              </md-content>
              <md-toolbar v-if="firstStepError" class="md-accent">
                <p class="">{{firstStepError}}</p>
              </md-toolbar>
            </md-card>
          </form>
          <!-- End form primo step -->
          <!--<md-button class="md-raised md-primary" @click="setDone('first', 'second')">Prosegui</md-button>-->
        </md-step>
        <!-- INIZIO SECONDO STEP-->
        <md-step id="second" md-label="Seleziona Piano Sanitario" :md-error="secondStepErrorTop" :md-editable="false" :md-done.sync="second">
          <div>
            <h1 style="line-height: 32px">Piano sanitario: Familiari - Figlio {{form.stato_civile == 0 ? 'Single' : 'Sposato'}}</h1>
            <h2 style="line-height: 32px">Contributo del piano sanitario: € {{costoPianoSanitario}}</h2>
          </div>
          <!-- Riepilogo -->
          <md-card>
            <md-card-header>
              <div class="md-title">Riepilogo domanda d'iscrizione</div>
            </md-card-header>

            <md-card-content class="md-layout md-gutter md-alignment-top-center">
              <md-table class="md-layout-item md-size-50  md-xsmall-size-100">
              <md-table-row >
                <md-table-head >
                  <span style="font-size: 18px;">Dati Anagrafici Caponucleo</span>
                </md-table-head>
                <!--<md-table-head></md-table-head>-->
              </md-table-row>

              <md-table-row>
                <md-table-cell>
                  Nome
                  <br>
                  <b v-if="mobilecheck()">{{form.nome_cn}}</b>
                </md-table-cell>
                <md-table-cell v-if="!mobilecheck()"><b>{{form.nome_cn}}</b></md-table-cell>
              </md-table-row>

              <md-table-row>
                <md-table-cell>Cognome
                  <br>
                  <b v-if="mobilecheck()">{{form.cognome_cn}}</b>
                </md-table-cell>
                <md-table-cell v-if="!mobilecheck()"><b>{{form.cognome_cn}}</b></md-table-cell>
              </md-table-row>

              <md-table-row>
                <md-table-cell>Codice Fiscale
                  <br>
                  <b v-if="mobilecheck()">{{form.cf_cn}}</b>
                </md-table-cell>
                <md-table-cell v-if="!mobilecheck()"><b>{{form.cf_cn}}</b></md-table-cell>
              </md-table-row>

              <md-table-row>
                <md-table-cell>Codice iscrizione al fondo
                  <br>
                  <b v-if="mobilecheck()">{{form.idnucleo}}</b>
                </md-table-cell>
                <md-table-cell v-if="!mobilecheck()"><b>{{form.idnucleo}}</b></md-table-cell>
              </md-table-row>

              <md-table-row>
                <md-table-cell>Progressivo codice iscrizione
                  <br>
                  <b v-if="mobilecheck()">{{form.prognucleo}}</b>
                </md-table-cell>
                <md-table-cell v-if="!mobilecheck()"><b>{{form.prognucleo}}</b></md-table-cell>
              </md-table-row>
            </md-table>

              <md-table class="md-layout-item md-size-50 md-xsmall-size-100">
                <md-table-row >
                  <md-table-head>
                    <span style="font-size: 18px;">Dati Anagrafici Caponucleo</span>
                  </md-table-head>
                  <md-table-head></md-table-head>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Nome
                    <br>
                    <b v-if="mobilecheck()">{{form.nome}}</b>
                  </md-table-cell>
                  <md-table-cell v-if="!mobilecheck()"><b>{{form.nome}}</b></md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Cognome
                    <br>
                    <b v-if="mobilecheck()">{{form.cognome}}</b>
                  </md-table-cell>
                  <md-table-cell v-if="!mobilecheck()"><b>{{form.cognome}}</b></md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Sesso
                    <br>
                    <b v-if="mobilecheck()">{{form.sesso}}</b>
                  </md-table-cell>
                  <md-table-cell v-if="!mobilecheck()"><b>{{form.sesso}}</b></md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Data di nascita
                  <br>
                  <b v-if="mobilecheck()">{{datePicker.day + '/' + datePicker.month + '/' + datePicker.year}}</b>
                  </md-table-cell>
                  <md-table-cell v-if="!mobilecheck()"><b>{{datePicker.day + '/' + datePicker.month + '/' + datePicker.year}}</b></md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Luogo di nascita
                  <br>
                  <b v-if="mobilecheck()">{{form.luogo_nascita}}</b>
                  </md-table-cell>
                  <md-table-cell v-if="!mobilecheck()"><b>{{form.luogo_nascita}}</b></md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Codice Fiscale
                  <br>
                  <b v-if="mobilecheck()">{{form.cf}}</b>
                  </md-table-cell>
                  <md-table-cell v-if="!mobilecheck()"><b>{{form.cf}}</b></md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Indirizzo
                  <br>
                  <b v-if="mobilecheck()">{{form.indirizzo}}</b>
                  </md-table-cell>
                  <md-table-cell v-if="!mobilecheck()"><b>{{form.indirizzo}}</b></md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>CAP
                  <br>
                  <b v-if="mobilecheck()">{{form.cap}}</b>
                  </md-table-cell>
                  <md-table-cell v-if="!mobilecheck()"><b>{{form.cap}}</b></md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Città
                  <br>
                  <b v-if="mobilecheck()">{{form.citta}}</b>
                  </md-table-cell>
                  <md-table-cell v-if="!mobilecheck()"><b>{{form.citta}}</b></md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Provincia
                  <br>
                  <b v-if="mobilecheck()">{{form.provincia}}</b>
                  </md-table-cell>
                  <md-table-cell v-if="!mobilecheck()"><b>{{form.provincia}}</b></md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Cellulare
                  <br>
                  <b v-if="mobilecheck()">{{form.cellulare}}</b>
                  </md-table-cell>
                  <md-table-cell v-if="!mobilecheck()"><b>{{form.cellulare}}</b></md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Email
                  <br>
                  <b v-if="mobilecheck()">{{form.email}}</b>
                  </md-table-cell>
                  <md-table-cell v-if="!mobilecheck()"><b>{{form.email}}</b></md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>Stato civile
                  <br>
                  <b v-if="mobilecheck()">{{form.stato_civile == 0 ? 'Single' : 'Convivente/Sposato'}}</b>
                  </md-table-cell>
                  <md-table-cell v-if="!mobilecheck()"><b>{{form.stato_civile == 0 ? 'Single' : 'Convivente/Sposato'}}</b></md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
            <!-- End riepilogo iscritto-->

          </md-card>
          <form novalidate style="padding: 30px 0 30px" class="md-layout md-gutter md-alignment-center-top" @submit.prevent="validateSubmission">
            <md-content class="md-layout-item md-size-100" :class="getValidationClass('privacy')">
              <span style="display: block; color: red" class="md-error" v-if="!form.privacy">Campo obbligatorio</span>
              <md-radio name="privacy" id="privacy" v-model="form.privacy" :value="true">INFORMATIVA AI SENSI DELL’ART. 13 D.LGS 30/06/2003, n.196
              </md-radio>
              <!--<span class="md-error" v-if="!$v.form.privacy.required">Campo obbligatorio</span>-->
            </md-content>
            <div class="md-layout-item md-size-100">
              <small>Accetto che i dati personali vengano trattati secondo l’informativa privacy presente su questo sito.
                <a target="_blank" href="https://www.assidai.it/download/PrivacyAssidai.pdf">Dichiaro di aver letto e di dare il Consenso
                  al trattamento dei dati personali.</a></small>
            </div>
          </form>
          <!-- End form secondo step -->
          <md-content style="padding: 10px 0 10px">
            <md-progress-spinner class="md-accent" md-mode="indeterminate" :md-diameter="30" v-if="sending"></md-progress-spinner>
          </md-content>
          <md-button style="background-color: rgb(255, 120, 55)" class="md-raised md-primary" @click="setDone('second', 'first')">Indietro</md-button>
          <md-button style="background-color: rgb(255, 120, 55)" class="md-raised md-primary" @click="validateSubmission()">Conferma iscrizione</md-button>

          <md-toolbar style="margin-top: 20px" v-if="secondStepError" class="md-accent">
            <p class="">{{secondStepError}}</p>
          </md-toolbar>

        </md-step>
        <md-step id="third" md-label="Domanda d'iscrizione completata" :md-editable="false" :md-done.sync="third">
          <div>
            <md-empty-state
                    class="md-primary"
                    md-icon="done"
                    md-label="Richiesta di iscrizione completata con successo."
                    md-description="Riceverai per e-mail le istruzioni per la compilazione del modulo di iscrizione">
            </md-empty-state>
          </div>
        </md-step>
      </md-steppers>
  </div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import {
    required,
    email,
    minLength,
    maxLength,
    minValue
  } from 'vuelidate/lib/validators'

  export default {
    name: 'FormAssidai',
    mixins: [validationMixin],
    data: () => ({
      active: 'first',
      first: false,
      second: false,
      third: false,
      firstStepError: null,
      firstStepErrorTop: null,
      secondStepError: null,
      secondStepErrorTop: null,
      datePickerData: {
        days: (year,month) => {
          if(month == null )
            return [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];

          var numDaysInMonth, daysInWeek, daysIndex, index, i, l, daysArray;

          numDaysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
          daysInWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
          daysIndex = { 'Sun': 0, 'Mon': 1, 'Tue': 2, 'Wed': 3, 'Thu': 4, 'Fri': 5, 'Sat': 6 };
          index = daysIndex[(new Date(year, month - 1, 1)).toString().split(' ')[0]];
          daysArray = [];

          for (i = 0, l = numDaysInMonth[month - 1]; i < l; i++) {
            daysArray.push((i + 1));
            if (index == 7) index = 0;
          }

          return daysArray;
        },
        months: [
          { text: 'Gennaio', value: '1'},
          { text: 'Febbraio', value: '2'},
          { text: 'Marzo', value: '3'},
          { text: 'Aprile', value: '4'},
          { text: 'Maggio', value: '5'},
          { text: 'Giugno', value: '6'},
          { text: 'Luglio', value: '7'},
          { text: 'Agosto', value: '8'},
          { text: 'Settembre', value: '9'},
          { text: 'Ottobre', value: '10'},
          { text: 'Novembre', value: '11'},
          { text: 'Dicembre', value: '12'},
        ],
        years: () => {let years = []; for (let i = 1964; i < 2019; i++) {years.push((i));} return years;}
      },
      datePicker: {
        day: null,
        month: null,
        year: null
      },
      form: {
        nome_cn: null,
        cognome_cn: null,
        cf_cn: null,
        email_cn: null,
        idnucleo: null,
        prognucleo: 0,
        nome: null,
        cognome: null,
        sesso: "M",
        dt_nascita: null,
        luogo_nascita: null,
        cf: null,
        indirizzo: null,
        citta: null,
        provincia: null,
        cellulare: null,
        email: null,
        stato_civile: 0,
        privacy: false,
        cap: null
      },
      pianiSanitari: {
        single: {
          first: '536',
          second: '561',
          third: '612'
        },
        coppie: {
          first: '1.158',
          second: '1.279'
        }
      },
      userSaved: false,
      sending: false,
      lastUser: null
    }),
    validations: {
      form: {
        nome_cn: {
          required,
          minLength: minLength(3)
        },
        cognome_cn: {
          required,
          minLength: minLength(3)
        },
        cf_cn: {
          required,
          minLength: minLength(16),
          maxLength: maxLength(16)
        },
        email_cn: {
          required,
          email
        },
        idnucleo: {
          required,
          integer: maxLength(64)
        },
        prognucleo: {
          required,
          integer: maxLength(1)
        },
        nome: {
          required,
          minLength: minLength(3)
        },
        cognome: {
          required,
          minLength: minLength(3)
        },
        sesso: {
          required
        },
        dt_nascita: {
          required,
          minValue: minValue(new Date('1 Jan 1964'))
        },
        luogo_nascita: {
          required,
          minLength: minLength(2),
          alphaSpaces: (val) => /^([^0-9]*)$/.test(val)
        },
        cf: {
          required,
          minLength: minLength(16),
          maxLength: maxLength(16)
        },
        indirizzo: {
          required,
          minLength: minLength(3)
        },
        citta: {
          required,
          alphaSpaces: (val) => /^([^0-9]*)$/.test(val),
          minLength: minLength(2)
        },
        provincia: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(2)
        },
        cellulare: {
          required,
          minLength: minLength(8)
        },
        email: {
          required,
          email
        },
        stato_civile: {
          required
        },
        cap: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(5)
        },
        // privacy: {
        //   required,
        //   mustBeTrue: (val) => val
        // }
      },
      datePicker: {
        day: {
          required
        },
        month: {
          required
        },
        year: {
          required,
          // minRange: (val) => (2019 - val) > 18,
          // maxRange: (val) => (2019 - val) < 55
        }
      }
    },
    beforeCreate: function (){
      // Imposto il locale per il datepicker
      this.$material.locale = {
        startYear: 1900,
        endYear: 2099,
        dateFormat: 'DD-MM-YYYY',
        days: ['Domenica', 'Lunedí', 'Martedí', 'Mercoledí', 'Giovedí', 'Venerdí', 'Sabato'],
        shortDays: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
        shorterDays: ['D', 'L', 'm', 'M', 'G', 'V', 'S'],
        months: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre',
          'Novembre', 'Dicembre'],
        shortMonths: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
        shorterMonths: ['G', 'F', 'M', 'A', 'M', 'J', 'L', 'A', 'S', 'O', 'N', 'D'],
        firstDayOfAWeek: 1
      }
    },
    methods: {
      upper(e) {
        e.target.value = e.target.value.toUpperCase()
      },
      mobilecheck() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
      },
      cityMonitor() {
        if(this.form.citta != null) {
          if(!/^([^0-9]*)$/.test(this.form.citta)) {
            console.log(this.form.citta.replace(new RegExp("[0-9]", "g"), ''));
            this.form.citta = this.form.citta.replace(new RegExp("[0-9]", "g"), '');
          }
        }

        if(this.form.luogo_nascita != null) {
          if(!/^([^0-9]*)$/.test(this.form.luogo_nascita)) {
            console.log(this.form.luogo_nascita.replace(new RegExp("[0-9]", "g"), ''));
            this.form.luogo_nascita = this.form.luogo_nascita.replace(new RegExp("[0-9]", "g"), '');
          }
        }
      },
      checkData () {
        this.sending = true;
        let that = this;
        // data.append('cf_cn', this.form.cf_cn);
        // data.append('idnucleo', this.form.idnucleo);
        // data.append('prognucleo', this.form.prognucleo);

        this.$http.get(window.endpoint.check,
          {params: {
            cf_cn:this.form.cf_cn,
              idnucleo: this.form.idnucleo,
              prognucleo: this.form.prognucleo,
              cf: this.form.cf}
          })
          .then((res) => {
            that.sending = false;
            if(res.body.success)
            {
              this.setDone('first', 'second');
              parent.postMessage('anchor', "*");
            } else {
              // this.setDone('first', 'second');
              this.setError('first', 'Errore: il codice fiscale e il codice di iscrizione del caponucleo non corrispondono ' +
                'e/o il codice fiscale del nuovo iscritto è già presente  in anagrafica, si prega di contattare il Fondo' +
                ' al numero 0644070600 dal lunedì al venerdì, dalle ore 9.00 alle 14.00 e dalle 15.00 alle 17.00');
            }
          })
          .catch((e) => { console.log(e); this.setError('first', 'Si è verificato un errore nella comunicazione con il database,' +
            'Si prega di riprovare'); })
      },
      sendData () {
        this.sending = true;
        let that = this;
        // let data = {};
        // for (var key in this.form) {
        //   if (this.form.hasOwnProperty(key)) {
        //     if(key == 'dt_nascita') {
        //       let temporary_date = new Date(this.form[key]);
        //       console.log(temporary_date.getTime());
        //       data[key] = temporary_date.getTime();
        //     } else {
        //       data[key] = this.form[key];
        //     }
        //   }
        // }
        // data.dt_nascita = this.form.dt_nascita.getTime();
        this.$http.get(window.endpoint.send, {params: this.form})
          .then((res) => {
            parent.postMessage('anchor', "*");
            this.sending = false;
            if(res.body.success) {
              this.$http.get(window.endpoint.mail, {params: this.form})
                .then(() => console.log('email succ sent'));
              this.setDone('second', 'third');
            } else {
              this.setError('second', 'Errore nel salvataggio dei dati, si prega di riprovare');
            }
          })
          .catch((e) => { console.log(e); this.setError('second', 'Si è verificato un errore nella comunicazione con il server. Si prega' +
            'di riprovare')})
      },
      setDone (id, index) {
        this[id] = true;

        this.firstStepError = null;
        this.firstStepErrorTop = null;
        this.secondStepError = null;
        this.secondStepErrorTop = null;
        if (index) {
          this.active = index
        }
      },
      setError (where = null, msg = null) {
        if(!msg) {
          if(where == 'first') {
            this.firstStepError = 'Si prega di verificare la corrispondenza del codice fiscale con il codice iscrizione ' +
              'al fondo, si è verificato un errore';
            this.firstStepErrorTop = 'Si è verificato un errore'
          } else {
            this.secondStepError = '';
            this.secondStepErrorTop = '';
          }
        }
        if(where == 'first')
        {
          this.firstStepError = msg;
          this.firstStepErrorTop = 'Si è verificato un errore';
        } else {
          this.secondStepError = msg;
          this.secondStepError = 'Si è verificato un errore';
        }
      },
      getValidationClass (fieldName, type = 'form') {
        const field = this.$v[type][fieldName];

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      validateUser () {
        this.$v.$touch();

        if (!this.$v.$invalid) {
          this.checkData()
        }
      },
      validateSubmission(){
        if (this.form.privacy) {
          this.sendData()
        }
      },
      getAge (birth) {
        return 2019 - birth;
      }
    },
    watch: {
      datePicker: {
        handler: function(val, oldVal) {
          if (val.day != null && val.month != null && val.year != null){
            this.form.dt_nascita = new Date(
              this.datePicker.month + '/' +
              this.datePicker.day + '/' +
              this.datePicker.year
            ).getTime();
          }
        },
        deep: true
      }
    },
    computed: {
      anno: function () {
        if(this.datePicker.year != null) {
          return this.datePicker.year;
        }
        return null;
      },
      /**
       * Return the cost of piano sanitario
       * @returns {number}
       */
      costoPianoSanitario: function() {
        // Eslcudo la possibilità che siano nulli
        if(this.form.stato_civile == null || this.anno == null)
          return 0;

        if(this.form.stato_civile == 0) {
          if(this.getAge(this.anno) <= 35) { return this.pianiSanitari.single.first }
          if(35 > this.getAge(this.anno) || this.getAge(this.anno) <= 45) { return this.pianiSanitari.single.second }
          if(this.getAge(this.anno) >= 46) { return this.pianiSanitari.single.third }
        }

        if(this.form.stato_civile == 1) {
          if(this.getAge(this.anno) <= 45) { return this.pianiSanitari.coppie.first }
          else { return this.pianiSanitari.coppie.second }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  i.md-icon.md-icon-font.md-empty-state-icon {
    color: rgb(255, 120, 55) !important;
  }

  .md-progress-bar {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }

  /*.md-table-cell-container {*/
    /*padding: 0px !important;*/
  /*}*/
  /*.md-table-head-label {*/
    /*padding-left: 0px !important;*/
  /*}*/
</style>
